
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum CordwoodMeasurementType {
    m3 = "m3",prm = "prm",npm = "npm",
}

export enum CordwoodMeasurementTypeDisplay {
    m3 = "m3",prm = "prm",npm = "npm",
}

export const CordwoodMeasurementTypePairs = Object.keys(CordwoodMeasurementType)
  .map(key=> ({id: key, name: CordwoodMeasurementType[key]}));

export function toString(value?: EnumSelect): string {
  return value ? CordwoodMeasurementType[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case CordwoodMeasurementTypeDisplay.m3:
            return t`m3`;
            
        case CordwoodMeasurementTypeDisplay.prm:
            return t`prm`;
            
        case CordwoodMeasurementTypeDisplay.npm:
            return t`npm`;
            
        default:
            return undefined;
    }
}
